import React, { useEffect, useRef, useState } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import axios from "axios";
import { baseurladdress } from "../baseurl";
import $ from "jquery";
import Select from "react-select";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Swal = require('sweetalert2');

function JobApplicant() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const [photoPreview, setPhotoPreview] = useState(null);
    const [photo, setPhoto] = useState(null);
    const [dob, setDob] = useState("");
    const [age, setAge] = useState("");
    const [resume, setResume] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [educationDetails, setEducationDetails] = useState([
        {
            qualification: "",
            specialization: "",
            college: "",
            year: "",
            percentage: ""
        }
    ]);
    const [photoError, setPhotoError] = useState("");
    const photoRef = useRef(null);
    const resumeRef = useRef(null);
    const emailRef = useRef(null);
    const [firstname, setFirstname] = useState("");
    const [middlename, setMiddlename] = useState("");
    const [lastname, setLastname] = useState("");
    const [gender, setGender] = useState("");
    // const [dob, setDob] = useState("");
    // const [age, setAge] = useState("");
    const [maritalstatus, setMaritalstatus] = useState("");
    const [nationality, setNationality] = useState("");
    const [mobilenumber, setMobilenumber] = useState("");
    const [altmobilenumber, setAltmobilenumber] = useState("");
    const [email, setEmail] = useState("");
    const [currentaddress, setCurrentaddress] = useState("");
    const [permanentaddress, setPermanentaddress] = useState("");
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [dist, setDist] = useState("");
    const [referencename, setReferencename] = useState("");
    const [referencerelation, setReferencerelation] = useState("");
    const [referencecompany, setReferencecompany] = useState("");
    const [referencecontact, setReferencecontact] = useState("");
    const [referenceemail, setReferenceemail] = useState("");
    const [linkedinprofile, setLinkedinprofile] = useState("");
    const [sameAddress, setSameAddress] = useState(false);

    const firstNameRef = useRef(null);
    const lastNameRef = useRef(null);
    const genderRef = useRef(null);
    const nationalityRef = useRef(null);
    const mobilenumberRef = useRef(null);
    const currentAddressRef = useRef(null);
    const permanentAddressRef = useRef(null);
    const qualificationRefs = useRef([]); 

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!firstname.trim()) {
            firstNameRef.current.focus();
            return;
        }
        if (!lastname.trim()) {
            lastNameRef.current.focus();
            return;
        }
        if (!gender.trim()) {
            genderRef.current.focus();
            return;
        }
        if (!nationality.trim()) {
            nationalityRef.current.focus();
            return;
        }
        if (!mobilenumber.trim()) {
            mobilenumberRef.current.focus();
            return;
        }
        if (!email.trim()) {
            emailRef.current.focus();
            return;
        }
        if (!currentaddress.trim()) {
            currentAddressRef.current.focus();
            return;
        }
        if (!permanentaddress.trim()) {
            permanentAddressRef.current.focus();
            return;
        }
        for (let i = 0; i < educationDetails.length; i++) {

            if (!educationDetails[i].qualification.trim()) {

                qualificationRefs.current[i]?.focus();

                return;
            }
        }
        if (!resume) {
            resumeRef.current?.focus();
            return;
        }
        const formData = new FormData();

        // Photo
        if (photo) {
            formData.append("photo", photo);
        }

        // Applicant Details
        formData.append("ddchr_app_firstname", firstname);
        formData.append("ddchr_app_middlename", middlename);
        formData.append("ddchr_app_lastname", lastname);
        formData.append("ddchr_app_gender", gender);
        formData.append("ddchr_app_dob", dob);
        formData.append("ddchr_app_age", age);
        formData.append("ddchr_app_maritalstatus", maritalstatus);
        formData.append("ddchr_app_nationality", nationality);
        formData.append("ddchr_app_mobnum", mobilenumber);
        formData.append("ddchr_app_altmob", altmobilenumber);
        formData.append("ddchr_app_email", email);
        formData.append("ddchr_app_currentaddress", currentaddress);

        formData.append("ddchr_app_permanentaddress", permanentaddress);
        formData.append("ddchr_app_country", country);
        formData.append("ddchr_app_state", state);
        formData.append("ddchr_app_district", dist);
        formData.append("educationDetails", JSON.stringify(educationDetails));
        formData.append("workExperience", JSON.stringify(workExperience));
        formData.append("ddchr_app_crtdby", accessuserid);
        formData.append("ddchr_app_refername", referencename);
        formData.append("ddchr_app_referrelation", referencerelation);
        formData.append("ddchr_app_refercompany", referencecompany);
        formData.append("ddchr_app_refermob", referencecontact);
        formData.append("ddchr_app_referemail", referenceemail);
        formData.append("ddchr_app_linkedin", linkedinprofile);
        if (resume) {
            formData.append("resume", resume);
        }
        try {

            const res = await axios.post(
                baseurladdress + "addjobapplicant",
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            if (res.data.status === "success") {

                clearForm();

                Swal.fire({
                    icon: "success",
                    title: "Application Submitted Successfully",
                    html: `
            <div style="font-size:15px;">
                <p>Your job application has been submitted successfully.</p>

                <div style="
                    background:#f8f9fa;
                    border:1px solid #dee2e6;
                    border-radius:8px;
                    padding:12px;
                    margin-top:10px;
                ">
                    <strong>Application ID</strong><br>
                    <span style="
                        color:#0d6efd;
                        font-size:20px;
                        font-weight:bold;
                        letter-spacing:1px;
                    ">
                        ${res.data.applicationId}
                    </span>
                </div>

                <p style="margin-top:15px;color:#6c757d;">
                    Please keep this Application ID for future reference.
                </p>
            </div>
        `,
                    confirmButtonText: "Done",
                    confirmButtonColor: "#0d6efd",
                    width: "500px",
                    allowOutsideClick: false
                });

            } else {

                Swal.fire({
                    icon: "error",
                    title: "Submission Failed",
                    text: "Unable to submit the application. Please try again.",
                    confirmButtonColor: "#dc3545"
                });

            }

        } catch (err) {

            console.error(err);

            Swal.fire({
                icon: "error",
                title: "Server Error",
                text: "An unexpected error occurred while submitting your application. Please try again later.",
                confirmButtonText: "OK",
                confirmButtonColor: "#dc3545"
            });

        }
    };
    const handlePhotoChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        setPhotoError(""); // Clear previous error

        // Allow only JPG, JPEG, and PNG
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

        if (!allowedTypes.includes(file.type)) {
            setPhotoError("Only JPG, JPEG, and PNG images are allowed.");

            e.target.value = "";
            setPhoto(null);
            setPhotoPreview(null);
            return;
        }

        // Maximum size: 1 MB
        const maxSize = 1 * 1024 * 1024;

        if (file.size > maxSize) {
            setPhotoError("Photo size must not exceed 1 MB.");

            e.target.value = "";
            setPhoto(null);
            setPhotoPreview(null);
            return;
        }

        setPhoto(file);
        setPhotoPreview(URL.createObjectURL(file));
        setPhotoError("");
    };   

    const handleSameAddress = (e) => {
        const checked = e.target.checked;

        setSameAddress(checked);

        if (checked) {
            setPermanentaddress(currentaddress);
        } else {
            setPermanentaddress("");
        }
    };
    const handleCurrentAddressChange = (e) => {
        const value = e.target.value;

        setCurrentaddress(value);

        if (sameAddress) {
            setPermanentaddress(value);
        }
    };
    const addQualification = () => {
        setEducationDetails([
            ...educationDetails,
            {
                qualification: "",
                specialization: "",
                college: "",
                year: "",
                percentage: ""
            }
        ]);
    };
    const [workExperience, setWorkExperience] = useState([
        {
            experienceType: "",
            totalExperience: "",
            relevantExperience: "",
            currentCompany: "",
            designation: "",
            currentCTC: "",
            expectedCTC: "",
            lastWorkingDate: "",
            reasonForLeaving: ""
        }
    ]);
    const clearForm = () => {

        setFirstname("");
        setMiddlename("");
        setLastname("");
        setGender("");
        setDob("");
        setAge("");
        setMaritalstatus("");
        setNationality("");
        setMobilenumber("");
        setAltmobilenumber("");
        setEmail("");
        setCurrentaddress("");
        setPermanentaddress("");
        setCountry("");
        setState("");
        setDist("");

        setReferencename("");
        setReferencerelation("");
        setReferencecompany("");
        setReferencecontact("");
        setReferenceemail("");
        setLinkedinprofile("");

        setEducationDetails([]);
        setWorkExperience([]);

        setPhoto(null);
        setResume(null);
      
        setPhotoPreview(null);
     

    
        if (photoRef.current) {
            photoRef.current.value = "";
        }

        if (resumeRef.current) {
            resumeRef.current.value = "";
        }
    };
    const deleteQualification = (index) => {
        const updated = educationDetails.filter((_, i) => i !== index);
        setEducationDetails(updated);
    };
    const handleEducationChange = (index, e) => {
        const { name, value } = e.target;

        const updated = [...educationDetails];
        updated[index][name] = value;

        setEducationDetails(updated);
    };
    const addWorkExperience = () => {
        setWorkExperience([
            ...workExperience,
            {
                experienceType: "",
                totalExperience: "",
                relevantExperience: "",
                currentCompany: "",
                designation: "",
                lastWorkingDate: "",
                reasonForLeaving: ""
            }
        ]);
    };
    const deleteWorkExperience = (index) => {
        setWorkExperience(
            workExperience.filter((_, i) => i !== index)
        );
    };
    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;

        const updated = [...workExperience];
        updated[index][name] = value;

        setWorkExperience(updated);
    };
    const calculateAge = (dob) => {
        if (!dob) return "";

        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();

        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (
            monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
            age--;
        }

        return age;
    };
    const getCountries = () => {
        axios
            .get(baseurladdress + "getcountry", {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {
                console.log("Countries:", res.data.response);
                const options = res.data.response.map((item) => ({
                    value: item.cntry_id,
                    label: item.cntry_name
                }));
                console.log("countryOptions =", options)
                setCountryOptions(options);

            })
            .catch((error) => {
                console.error(error);
                toast.error("Failed to load countries");
            });
    };
    const currentYear = new Date().getFullYear();
    const years = Array.from(
        { length: currentYear - 1989 },
        (_, i) => currentYear - i
    );
    useEffect(() => {
        getCountries();
    }, []);

    //getstates
    const getStates = async (countryId) => {
        try {
            const res = await axios.get(
                baseurladdress + "getstates/" + countryId,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            const options = res.data.response.map((item) => ({
                value: item.state_id,
                label: item.state_name,
            }));

            setStateOptions(options);

            return options;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    // get Districts
    const getDistricts = async (stateId) => {
        try {
            const res = await axios.get(
                baseurladdress + "getdistrict/" + stateId,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            const options = res.data.response.map((item) => ({
                value: item.district_id,
                label: item.district_name,
            }));

            setDistrictOptions(options);

            return options;
        } catch (error) {
            console.error(error);
            return [];
        }
    };


    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <style>{`
`}</style>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
            />
            <div className="content-wrap">
                <div className="main container-fluid">
                    <section id="main-content">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h6 className="card-title">Job Applicant</h6>
                                <div className="d-flex align-items-center">

                                </div>
                            </div>
                            <div className="card job-card">

                                <div className="card-header job-card-header">
                                    <h5 className="mb-0">
                                        <i className="fa fa-address-card text-primary mr-2"></i>
                                        Basic Information
                                    </h5>
                                </div>
                                <div class="card-body">
                                    <div className="basic-form">

                                        <div className="row">

                                            {/* Left Side */}
                                            <div className="col-md-9">

                                                <div className="row">

                                                    <div className="col-md-4 mb-3">
                                                        <h6><span style={{ color: "red" }}>*</span> First Name</h6>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="First Name"
                                                            ref={firstNameRef}
                                                            value={firstname}
                                                            onChange={(e) => setFirstname(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <h6>Middle Name</h6>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Middle Name"
                                                            value={middlename}
                                                            onChange={(e) => setMiddlename(e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <h6><span style={{ color: "red" }}>*</span> Last Name</h6>
                                                        <input
                                                            type="text"
                                                            ref={lastNameRef}
                                                            className="form-control"
                                                            placeholder="Last Name"
                                                            value={lastname}
                                                            onChange={(e) => setLastname(e.target.value)}
                                                        />
                                                    </div>

                                                    {/* Second Row */}

                                                    <div className="col-md-4 mb-3">
                                                        <h6><span style={{ color: "red" }}>*</span> Gender</h6>
                                                        <select className="form-control"
                                                            ref={genderRef}
                                                            value={gender} onChange={(e) => setGender(e.target.value)}>
                                                            <option value="0">Choose...</option>
                                                            <option value="1">Male</option>
                                                            <option value="2">Female</option>
                                                            <option value="3">Others</option>
                                                        </select>
                                                    </div>

                                                    <div className="col-md-4 mb-3">
                                                        <h6>Date of Birth</h6>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={dob}
                                                            onChange={(e) => {
                                                                setDob(e.target.value);
                                                                setAge(calculateAge(e.target.value));
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-md-4 mb-3">
                                                        <h6>Age</h6>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={age}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <h6>Marital Status</h6>
                                                        <select className="form-control" value={maritalstatus} onChange={(e) => setMaritalstatus(e.target.value)}>
                                                            <option value="0">Choose...</option>
                                                            <option value="1">Single</option>
                                                            <option value="2">Married</option>
                                                            <option value="3">Unmarried</option>
                                                            <option value="4">Divorced</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <h6><span style={{ color: "red" }}>*</span>Nationality</h6>
                                                        <input
                                                            ref={nationalityRef }
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Nationality"
                                                            value={nationality}
                                                            onChange={(e) => setNationality(e.target.value)}
                                                        />
                                                    </div>



                                                </div>
                                            </div>


                                            {/* Right Side Photo */}
                                            <div className="col-md-3 text-center">

                                                <div
                                                    style={{
                                                        width: "170px",
                                                        height: "200px",
                                                        border: "2px dashed #ced4da",
                                                        borderRadius: "10px",
                                                        margin: "0 auto",
                                                        overflow: "hidden",
                                                        background: "#f8f9fa",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                >
                                                    {photoPreview ? (
                                                        <img
                                                            src={photoPreview}
                                                            alt="Applicant"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "cover"
                                                            }}
                                                        />
                                                    ) : (
                                                        <span className="text-muted">
                                                            Applicant Photo
                                                        </span>
                                                    )}
                                                </div>

                                                <input
                                                    type="file"
                                                    id="photo"
                                                    hidden
                                                    accept=".jpg,.jpeg,.png,image/jpeg,image/png"

                                                   // accept="image/*"
                                                    ref={photoRef}
                                                 
                                                    onChange={handlePhotoChange}
                                                />
                                                
                                                {photoError && (
                                                    <div className="text-danger small mt-2">
                                                        {photoError}
                                                    </div>
                                                )}

                                                <label
                                                    htmlFor="photo"
                                                    className="btn btn-primary mt-3 w-100"
                                                >
                                                    Upload Photo
                                                </label>

                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>

                            <div className="card job-card">

                                <div className="card-header job-card-header">
                                    <h5 className="mb-0">
                                        <i className="fa fa-phone text-primary mr-2"></i>
                                        Contact Information
                                    </h5>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <h6><span style={{ color: "red" }}>*</span> Mobile Number</h6>
                                        <input
                                            ref={mobilenumberRef}
                                            type="text"
                                            className="form-control"
                                            placeholder="Mobile Number"
                                            value={mobilenumber}
                                            onChange={(e) => setMobilenumber(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <h6>Alternate Mobile Number</h6>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Alternate Mobile Number"
                                            value={altmobilenumber}
                                            onChange={(e) => setAltmobilenumber(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <h6><span style={{ color: "red" }}>*</span> Email Address</h6>
                                        <input
                                            type="email"
                                            ref={emailRef}
                                            className="form-control"
                                            placeholder="Email Address"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                    {/* <div className="col-md-6 mb-3">
                                        <h6><span style={{ color: "red" }}>*</span> Current Address</h6>
                                        <textarea className="form-control" rows="3" placeholder="Current Address" value={currentaddress} onChange={(e) => setCurrentaddress(e.target.value)}></textarea>

                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <h6><span style={{ color: "red" }}>*</span> Permanent Address</h6>
                                        <textarea className="form-control" rows="3" placeholder="Permanent Address" value={permanentaddress} onChange={(e) => setPermanentaddress(e.target.value)}></textarea>
                                    </div>*/}

                                    <div className="col-md-6 mb-3">
                                        <h6>
                                            <span style={{ color: "red" }}>*</span> Current Address
                                        </h6>

                                        <textarea
                                            ref={currentAddressRef}
                                            className="form-control"
                                            rows="3"
                                            placeholder="Current Address"
                                            value={currentaddress}
                                            onChange={handleCurrentAddressChange}
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">

                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0">
                                                <span style={{ color: "red" }}>*</span> Permanent Address
                                            </h6>

                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="sameAddress"
                                                    checked={sameAddress}
                                                    onChange={handleSameAddress}
                                                />
                                                <label className="form-check-label" htmlFor="sameAddress">
                                                    Same as current address
                                                </label>
                                            </div>
                                        </div>

                                        <textarea
                                            className="form-control mt-2"
                                            rows="3"
                                            placeholder="Permanent Address"
                                            value={permanentaddress}
                                            onChange={(e) => setPermanentaddress(e.target.value)}
                                            disabled={sameAddress}
                                            ref={permanentAddressRef}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <h6 className="form-label">
                                            Country
                                        </h6>

                                        <Select
                                            options={countryOptions}
                                            value={selectedCountry}
                                            onChange={(selected) => {
                                                setSelectedCountry(selected);
                                                setCountry(selected ? selected.value : "");

                                                setSelectedState(null);
                                                setState("");

                                                setSelectedDistrict(null);
                                                setDist("");

                                                if (selected) {
                                                    getStates(selected.value);
                                                }
                                            }}
                                            placeholder="Select Country"
                                            isSearchable
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <h6 className="form-label">
                                            State
                                        </h6>

                                        <Select
                                            options={stateOptions}
                                            value={selectedState}
                                            onChange={(selected) => {
                                                setSelectedState(selected);
                                                setState(selected ? selected.value : "");

                                                setSelectedDistrict(null);
                                                setDist("");

                                                if (selected) {
                                                    getDistricts(selected.value);
                                                }
                                            }}
                                            placeholder="Select State"
                                            isSearchable
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <h6 className="form-label">
                                            District
                                        </h6>

                                        <Select
                                            options={districtOptions}
                                            value={selectedDistrict}
                                            onChange={(selected) => {
                                                setSelectedDistrict(selected);
                                                setDist(selected ? selected.value : "");
                                            }}
                                            placeholder="Select District"
                                            isSearchable
                                        />
                                    </div>

                                </div>

                            </div>


                            <div className="card job-card">

                                <div className="card-header job-card-header">
                                    <h5 className="mb-0">
                                        <i className="fa fa-graduation-cap text-primary mr-2"></i>
                                        Education Details
                                    </h5>
                                    <i
                                        className="fa fa-plus"
                                        onClick={addQualification}
                                        style={{
                                            color: "green",
                                            fontSize: "16px",
                                            cursor: "pointer"
                                        }}
                                        title="Add Qualification"
                                    ></i>
                                </div>
                                {educationDetails.map((item, index) => (
                                    <div className="row mb-3" key={index}>

                                        <div className="col-md-4">
                                            <h6><span style={{ color: "red" }}>*</span>Qualification</h6>
                                            <input
                                                ref={(el) => (qualificationRefs.current[index] = el)}
                                                type="text"
                                                name="qualification"
                                                className="form-control"
                                                placeholder="Qualification"
                                                value={item.qualification}
                                                onChange={(e) => handleEducationChange(index, e)}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <h6>Specialization</h6>
                                            <input
                                                type="text"
                                                name="specialization"
                                                className="form-control"
                                                placeholder="Specialization"
                                                value={item.specialization}
                                                onChange={(e) => handleEducationChange(index, e)}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <h6>University / College</h6>
                                            <input
                                                type="text"
                                                name="college"
                                                className="form-control"
                                                placeholder="University / College"
                                                value={item.college}
                                                onChange={(e) => handleEducationChange(index, e)}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <h6>
                                                Year of Passing
                                            </h6>

                                            <select
                                                name="year"
                                                className="form-control"
                                                value={item.year}
                                                onChange={(e) => handleEducationChange(index, e)}
                                            >
                                                <option value="">Select Year</option>

                                                {years.map((year) => (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <h6>Percentage / CGPA</h6>
                                            <input
                                                type="text"
                                                name="percentage"
                                                className="form-control"
                                                placeholder="80% / 8.5 CGPA"
                                                value={item.percentage}
                                                onChange={(e) => handleEducationChange(index, e)}
                                            />
                                        </div>
                                        <div className="col-md-4 my-4">
                                            <i
                                                className="fa fa-times"
                                                onClick={() => deleteQualification(index)}
                                                style={{
                                                    color: "red",
                                                    fontSize: "18px",
                                                    cursor: "pointer"
                                                }}
                                                title="Delete Qualification"
                                            ></i>
                                        </div>


                                    </div>
                                ))}



                            </div>

                            <div className="card job-card">

                                <div className="card-header job-card-header">
                                    <h5 className="mb-0">
                                        <i className="fa fa-building text-primary mr-2"></i>
                                        Work Experience
                                    </h5>
                                    <i
                                        className="fa fa-plus"
                                        onClick={addWorkExperience}
                                        style={{
                                            color: "green",
                                            fontSize: "16px",
                                            cursor: "pointer"
                                        }}
                                        title="Add Qualification"
                                    ></i>
                                </div>
                                {workExperience.map((item, index) => (
                                    <div className="row mb-3" key={index}>

                                        <div className="col-md-4">
                                            <h6>Experienced/Fresher</h6>
                                            <input
                                                type="text"
                                                name="experienceType"
                                                className="form-control"
                                                placeholder="Experienced/Fresher"
                                                value={item.experienceType}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <h6>Total Experience (in years)</h6>
                                            <input
                                                type="text"
                                                name="totalExperience"
                                                className="form-control"
                                                placeholder="experience"
                                                value={item.totalExperience}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                            />
                                        </div>


                                        <div className="col-md-4">
                                            <h6>Relevent Experience (in years)</h6>
                                            <input
                                                type="text"
                                                name="relevantExperience"
                                                className="form-control"
                                                placeholder="Revelent Year"
                                                value={item.relevantExperience}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <h6>Current Company</h6>
                                            <input
                                                type="text"
                                                name="currentCompany"
                                                className="form-control"
                                                placeholder="current company"
                                                value={item.currentCompany}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <h6>Designation</h6>
                                            <input
                                                type="text"
                                                name="designation"
                                                className="form-control"
                                                placeholder="Designation"
                                                value={item.designation}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <h6>Last Working Date</h6>
                                            <input
                                                type="date"
                                                name="lastWorkingDate"
                                                className="form-control"
                                                placeholder="lastWorkingDate"
                                                value={item.lastWorkingDate}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                            />
                                        </div>
                                        <div className="col-md-9">
                                            <h6>Reason For Leaving</h6>
                                            <input
                                                type="text"
                                                name="reasonForLeaving"
                                                className="form-control"
                                                placeholder="Reason for leaving"
                                                value={item.reasonForLeaving}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                            />
                                        </div>
                                        <div className="col-md-3 my-4">
                                            <i
                                                className="fa fa-times"
                                                onClick={() => deleteWorkExperience(index)}
                                                style={{
                                                    color: "red",
                                                    fontSize: "18px",
                                                    cursor: "pointer"
                                                }}
                                                title="Delete Work Experience"
                                            ></i>
                                        </div>


                                    </div>
                                ))}



                            </div>

                            <div className="card job-card">

                                <div className="card-header job-card-header">
                                    <h5 className="mb-0">
                                        <i className="fa fa-paperclip text-primary mr-2"></i>
                                        Documents Upload
                                    </h5>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <h6><span style={{ color: "red" }}>*</span> Resume</h6>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept=".pdf,.doc,.docx"
                                            ref={resumeRef}
                                            onChange={(e) => setResume(e.target.files[0])}
                                        />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <h6>LinkedIn Profile</h6>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="LinkedIn Profile"
                                            value={linkedinprofile}
                                            
                                            onChange={(e) => setLinkedinprofile(e.target.value)}
                                        />
                                    </div>
                                </div>

                            </div>

                            <div className="card job-card">

                                <div className="card-header job-card-header">
                                    <h5 className="mb-0">
                                        <i className="fa fa-address-card text-primary mr-2"></i>
                                        Reference Details
                                    </h5>
                                </div>
                                <div className="row">

                                    <div className="col-md-4 mb-3">
                                        <h6>Reference Name</h6>
                                        <input type="text" className="form-control" placeholder="Reference Name"
                                            value={referencename}
                                            onChange={(e) => setReferencename(e.target.value)} />


                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <h6>Relationship</h6>
                                        <input type="text" className="form-control"
                                            placeholder="Relationship"
                                            value={referencerelation} onChange={(e) => setReferencerelation(e.target.value)} />

                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <h6>Company Name</h6>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Company Name"
                                            value={referencecompany}
                                            onChange={(e) => setReferencecompany(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <h6>Referer Mobilenum</h6>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Referer Mobilenum"
                                            value={referencecontact}
                                            onChange={(e) => setReferencecontact(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <h6>Referer Email</h6>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Referer Email"
                                            value={referenceemail}
                                            onChange={(e) => setReferenceemail(e.target.value)}
                                        />
                                    </div>

                                </div>

                            </div>




                            <div className="row mt-3">
                                <div className="col-12 d-flex justify-content-center">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSubmit}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>




                        </div>




                    </section>
                </div>
            </div>
        </div>
    );
}

export default JobApplicant;
